import React from "react";
import "./style.css";
import usaImage from "../../assets/usa.webp";
import Particles from "../Particles/Particles";

import university1 from "../../assets/university-logos/usa/Alabama_State_University.webp";
import university2 from "../../assets/university-logos/usa/Arizona_University.webp";
import university3 from "../../assets/university-logos/usa/Arkansas_State_University.webp";
import university4 from "../../assets/university-logos/usa/Boston-University.webp";
import university5 from "../../assets/university-logos/usa/Southeast_Missouri_University.webp";
import university6 from "../../assets/university-logos/usa/Southwest_Minnesota_University.webp";
import university7 from "../../assets/university-logos/usa/University_of_Louisiana.webp";
import university8 from "../../assets/university-logos/usa/University_of_Pennsylvania.webp";

const universityList = [
  { id: Math.random(), image: university1 },
  { id: Math.random(), image: university2 },
  { id: Math.random(), image: university3 },
  { id: Math.random(), image: university4 },
  { id: Math.random(), image: university5 },
  { id: Math.random(), image: university6 },
  { id: Math.random(), image: university7 },
  { id: Math.random(), image: university8 },
];

const USA = () => {
  return (
    <>
      <Particles
        title="Study in USA"
        subTitle="Navigate the Future with a USA Degree"
        image={usaImage}
      />
      <div className="short-description container">
        <h1 className="text-left">Study in USA</h1>
        <p className="text-justify">
          The United States has long welcomed international students, viewing
          them as vital to both its communities and its economy. Known for its
          dynamic lifestyle, multicultural society, and strong global influence,
          the U.S. offers students an enriched cultural experience with a wide
          array of cuisines, religions, languages, and traditions. As a result,
          it remains one of the top destinations for learners worldwide. The
          country is made up of 50 states, each hosting leading universities and
          colleges that offer high‑quality education to thousands of
          international students annually. While English is the official
          language, American English features its own distinctive expressions
          and regional slang that newcomers often enjoy discovering.
          <br /> <br />
          <strong>Educraft Education Network</strong> has long assisted Nepali
          students in securing student visas and gaining admission to American
          colleges and universities. We are committed to guiding students who
          aspire to study abroad and pursue global academic opportunities.
          Today, more individuals are venturing beyond their home borders in
          search of superior education and career prospects—and the United
          States has emerged as a top destination thanks to its world‑class
          institutions, inclusive environment, and promising futures. At
          Educraft, we support you throughout the entire journey—from selecting
          the ideal program and university, to preparing your application
          materials and applying for your visa. Our dedicated team of experts is
          here to ensure that your path to studying in the U.S. is smooth,
          secure, and successful.
        </p>
      </div>

      <div className="why-study container">
        <h1 className="text-left">Why study in USA? </h1>
        <p className="text-left">
          The United States has consistently attracted international students
          from around the globe. Here are some persuasive reasons to choose the
          USA for your higher education:
        </p>
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="first-tab"
              data-bs-toggle="tab"
              data-bs-target="#first"
              type="button"
              role="tab"
              aria-controls="first"
              aria-selected="true"
            >
              Academic Excellence
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="second-tab"
              data-bs-toggle="tab"
              data-bs-target="#second"
              type="button"
              role="tab"
              aria-controls="second"
              aria-selected="false"
            >
              Diverse Study Programs
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="third-tab"
              data-bs-toggle="tab"
              data-bs-target="#third"
              type="button"
              role="tab"
              aria-controls="third"
              aria-selected="false"
            >
              Innovation and Research
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="fourth-tab"
              data-bs-toggle="tab"
              data-bs-target="#fourth"
              type="button"
              role="tab"
              aria-controls="fourth"
              aria-selected="false"
            >
              Global Recognition
            </button>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane show active"
            id="first"
            role="tabpanel"
            aria-labelledby="first-tab"
          >
            <h6>
              U.S. universities regularly rank among the world's finest—MIT,
              Harvard, Stanford, and Johns Hopkins are frequently in the global
              top tier. They offer rigorous curricula, world-class faculty, and
              abundant resources that foster critical thinking and academic
              excellence.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="second"
            role="tabpanel"
            aria-labelledby="second-tab"
          >
            <h6>
              The American higher education system boasts over 3,900 accredited
              institutions, offering a vast spectrum of undergraduate, graduate,
              and specialized programs—from engineering and medicine to arts and
              social sciences leapscholar.com . Its flexible structure lets
              students explore different fields, double-major, combine
              disciplines, or switch paths to best align with their evolving
              interests and career aspirations.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="third"
            role="tabpanel"
            aria-labelledby="third-tab"
          >
            <h6>
              The U.S. leads the world in research funding and technological
              breakthroughs, supporting cutting-edge investigations in AI,
              biotech, medicine, and more leapscholar.com +1 time.com +1 .
              Engaging in innovative labs, students collaborate with top-tier
              researchers, sometimes contributing to patentable discoveries and
              startup ventures.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="fourth"
            role="tabpanel"
            aria-labelledby="fourth-tab"
          >
            <h6>
              A degree from a U.S. institution carries significant international
              prestige—more than half of the world’s top 100 universities are
              based in the U.S., and its degrees are respected across global
              industries lcig.io . Graduates gain a considerable advantage in
              the international job market, enhanced by strong alumni networks
              and leadership development through programs like OPT that blend
              academic results with career preparation.
            </h6>
          </div>
        </div>
      </div>

      <div className="university-partners container">
        <h1 className="text-left">Our University Partner in USA</h1>
        <div className="row">
          {universityList?.map((list) => (
            <div key={list.id} className="col-6 col-md-4 col-lg-3 p-2">
              <div className="partner-box">
                <img src={list.image} alt="university logo" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default USA;
